import Request from '@/core/QuRequest';

import * as $cache from '@/common/cache';

const req = new Request();

export default {
  methods: {
    // 获取公共参数
    getParams() {
      const [start, end] = this.date;
      const params = {
        start_date: start.format(this.$REQUEST_DATE_FORMAT),
        end_date: end.format(this.$REQUEST_DATE_FORMAT),
        stop_days: this.stopDays
      };
      return params;
    },

    // 获取汇总信息
    async querySummary() {
      const params = this.getParams();
      const data = await req.send(req.Apis.sales.report.productReportSummary, params);

      try {
        const { list, latestTime } = data.data;
        this.summary = list;
        this.summaryLoading = false;
        this.lastUpdateTime = latestTime;
      } catch (err) {
        this.$message.error(`获取详细数据失败：${err.message || '未知错误'}`);
      }
    },

    // 获取停投产品数
    async queryStopProductSummary() {
      const params = this.getParams();
      const data = await req.send(req.Apis.sales.report.productReportSummaryStop, params);

      try {
        this.summary = this.summary.map(item => {
          if (item.key === data.data.key) return data.data;
          return item;
        });
      } catch (err) {
        this.$message.error(`获取详细数据失败：${err.message || '未知错误'}`);
      }
    },

    // 获取汇总折线图数据
    async queryMyPerformance() {
      const params = this.getParams();
      params.dimension = this.dimension;
      params.indexes = this.field;

      const data = await req.send(req.Apis.sales.report.productReportMyPerformance, params);

      try {
        this.rawChartData = data.data;
        this.chartLoading = false;
      } catch (err) {
        this.$message.error(`获取详细数据失败：${err.message || '未知错误'}`);
      }
    },

    // 获取 TOP10 折线图数据
    async queryTopTen() {
      const params = this.getParams();
      params.dimension = this.dimension;
      params.index = this.field;

      const data = await req.send(req.Apis.sales.report.productReportTopTen, params);

      try {
        this.rawChartData = data.data;
        this.chartLoading = false;
      } catch (err) {
        this.$message.error(`获取详细数据失败：${err.message || '未知错误'}`);
      }
    },

    // 获取详细数据列表
    async queryList() {
      const params = this.getParams();
      params.page = this.page;
      params.page_size = this.pageSize;
      params.order_by = this.order;
      params.dimension = this.dimension;
      params.filters = this.filters;
      params.fields = this.fields.join(',');

      const data = await req.send(req.Apis.sales.report.productReportList, params);

      try {
        this.tableLoading = false;
        this.rawTableData = data.data;
      } catch (err) {
        this.$message.error(`获取详细数据失败：${err.message || '未知错误'}`);
      }
    },

    async download() {
      // const form = document.createElement('form');
      // form.id = 'downloadForm';
      // form.name = 'tableDownloadHelper';
      // document.body.appendChild(form);
      // for (let key in params) {
      //   if (params.hasOwnProperty(key)) {
      //     if (key !== 'filters') {
      //       const input = document.createElement('input');
      //       input.type = 'hidden';
      //       input.name = key;
      //       input.value = params[key];
      //       form.appendChild(input);
      //     } else {
      //       params[key].forEach((value) => {
      //         const input = document.createElement('input');
      //         input.type = 'hidden';
      //         input.name = 'filters[]';
      //         input.value = value;
      //         form.appendChild(input);
      //       });
      //     }
      //   }
      // }
      // form.method = 'POST';
      // form.action = req.getUrl(req.Apis.sales.report.productReportDownload);
      // form.submit();
      // document.body.removeChild(form);
    },
  },
};
